import InputType from '@/components/tableCells/InputType';
import { isPositiveInteger } from '@/utils/reg';
import { isFunction } from '@/utils/common';
export default {
	props: {
		column: {
			type: Object,
			default: () => {
				return {};
			},
		},
		row: {
			type: Object,
			default: () => {
				return {};
			},
		},
		rowIsHover: {
			type: Boolean,
			default: false,
		},
		rowIndex: {
			type: Number,
			default: 0,
		},
		tabName: {
			type: String,
			default: () => {
				return '0';
			},
		},
		useByTable: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			hasError: false,
			errorMsg: '',
			warningMsg: '',
		};
	},
	computed: {
		cellValue() {
			const val = this.row[this.column.key];
			if (typeof val === 'number') {
				return val;
			}
			return val || '';
		},
		// 组件配置信息 默认使用table，其次是非table应用场景 => 注意配置信息只会初始化一次
		calcConf() {
			const { useByTable, defaultColumn, _props, column } = this;
			if (useByTable) {
				// 主要用于一些组件配置需要根据row原始数据动态变化的
				Object.keys(this.column).forEach(key => {
					if (isFunction(this.column[key]) && key !== 'type' && key !== 'transform') {
						this.column[key] = this.column[key](this.row);
					}
				});
				// 使用table模式，导致props默认值丢失，这里做一些常用默认值初始化，配置在组件中
				return defaultColumn ? { ...defaultColumn, ...column } : column;
			} else {
				return _props;
			}
		},
		calcValue() {
			// console.log(this.row)
			return (childKey, isValueKey = false) => {
				if (this.useByTable) {
					if (Array.isArray(childKey)) {
						// table中，约定所要取的值在第一层
						childKey = childKey[childKey.length - 1];
					}
					if (childKey !== this.column.key && isValueKey) {
						//1. 表示当前非key配置信息也需要根据row变化来变化 2. rdText 传入值和其column配置肯定不一样的
						return this.row[childKey];
					}
					return this.row[this.column.key || childKey];
				} else {
					/**
					 * 1. 简单值场景
					 * 2. 对象场景
					 */
					if (Array.isArray(childKey)) {
						var ret = this;
						childKey.forEach(key => {
							ret = ret && ret[key];
						});
						return ret;
					}
					return this[childKey];
				}
			};
		},
		suffixIcon() {
			let icon = '';
			switch (this.column.inputType) {
				case InputType.Percent:
				case InputType.PercentInt:
					icon = '%';
					break;
				default:
					break;
			}
			return icon;
		},
		prefixIcon() {
			let icon = '';
			switch (this.column.inputType) {
				case InputType.Price:
					icon = '￥';
					break;
				default:
					break;
			}
			return icon;
		},
	},
	methods: {
		disabled() {
			if (typeof this.column.disabled === 'function') {
				return this.column.disabled(this.row, this.value);
			}
			return this.column.disabled || false;
		},
		updateValue() {
			if (!this.validValue()) {
				const min = this.column.min || this.row.min;
				const max = this.column.max || this.row.max;

				// 校验失败了，弹窗提示，数据存在问题, 并初始化该数据
				const errorMsg = '可填入值范围为' + min + '-' + max;

				this.row.error = {
					...(this.row.error || {}),
				};
				this.row.error[this.column.key] = errorMsg;
				this.$message.error(errorMsg);
				// if (typeof this.column.initValue === 'function') {
				//     this.value = this.column.initValue(this.row, this.value);
				//     this.row[this.column.key] = this.value;
				// }
				// return;
			} else {
				if (this.row.error && this.row.error[this.column.key]) {
					delete this.row.error[this.column.key];
				}
			}
			this.row[this.column.key] = this.value;
			this.hasError = this.hasErrorFn();
			this.warningMsg = this.row?.warningMsg?.[this.column.key] || '';
			this.$emit('change', this.value);
		},
		hasErrorFn() {
			if (this.row.error && this.row.error[this.column.key]) {
				this.errorMsg = this.row.error[this.column.key];
				return true;
			}
			return false;
		},
		validValue() {
			let valid = true;
			switch (this.column.inputType) {
				case InputType.Price:
				case InputType.Int:
				case InputType.Number:
				case InputType.Percent:
				case InputType.PercentInt:
					valid = this.validValueNumber();
					break;
				default:
					break;
			}
			return valid;
		},
		validValueNumber() {
			const val = Number(this.value);
			const min = this.column.min;
			const max = this.column.max;
			if (isNaN(val)) {
				return false;
			}
			if (val < min && min != undefined) {
				return false;
			}
			if (val > max && max != undefined) {
				return false;
			}
			if (typeof this.column.valid === 'function') {
				if (!this.column.valid(this.row, this.value)) {
					return false;
				}
			}

			return true;
		},
		// 输入过程中对输入的内容做校验，不符合要求的时候，直接清除非法字符
		inputValue(val) {
			// 先把非法字符过滤掉
			switch (this.column.inputType) {
				case InputType.Int:
				case InputType.Number:
				case InputType.PercentInt:
					this.value = val.replace(/[^0-9]/g, '');
					break;
				default:
					this.value = val.replace(/[^0-9|\.]/g, '');
					break;
			}
			val = this.value;
			const number_v = Number(val);
			switch (this.column.inputType) {
				case InputType.Price:
				case InputType.Percent:
					if (!isNaN(number_v)) {
						// if (isValidPriceReg.test(val)) {
						return;
						// }
					}
					// 是NaN的话，表示最近输入的字符有误，直接删除。
					// 不是正常的价格的话，表示最近输入的值也有问题，可能大于2个小数了
					// 然后走后面的slice逻辑

					break;
				case InputType.Number:
					if (!isNaN(number_v)) {
						return;
					}
					break;

				case InputType.Int:
				case InputType.PercentInt:
					if (!isNaN(number_v)) {
						if (isPositiveInteger.test(val + '')) {
							return;
						}
					}

					break;
				default:
					return;
			}
			// 前面的校验没有问题的时候，直接return了，就不需要删除最后一个字符
			this.value = val.slice(0, val.length - 1);
		},
	},
};
